import React from "react";
import { Box, Button } from "@showitinc/showit-wc";
import _ from "lodash";
import AppConstants from "../constants/AppConstants";
import UIActions from "../actions/UIActions";
import Modal from "./base/Modal";
import uiPrefix from "../utils/UiPrefixUtils";
import ButtonBar from "./base/ButtonBar";
import Glyphicon from "./base/Glyphicon";

class ActionConfirmModal extends React.Component {
  static defaultProps = {
    cancelBtn: "Cancel",
    confirmBtn: "Ok",
    title: "",
    question: "",
    message: "",
    cancelAction: null,
    confirmAction: null,
    alertMode: false,
  };

  _cancel = () => {
    if (this.props.cancelAction) {
      this.props.cancelAction();
    }

    UIActions.modalClose(AppConstants.MODAL_ACTION_CONFIRM);
  };

  _confirm = () => {
    if (this.props.confirmAction) {
      this.props.confirmAction();
    }

    UIActions.modalClose(AppConstants.MODAL_ACTION_CONFIRM);
  };

  render() {
    const { cancelBtn, confirmBtn, title, message, question, alertMode, icon } = this.props;

    let modalProps = _.pick(this.props, Modal.BASIC_PROPS);

    let headerConfig = {};

    if (!alertMode) {
      _.set(headerConfig, "closeButton", true);
    }

    return (
      <Modal {...modalProps} backdrop="static">
        <Modal.Dialog>
          <Modal.Dialog.Header {...headerConfig}>
            <Modal.Dialog.Title>{title}</Modal.Dialog.Title>
          </Modal.Dialog.Header>
          <Modal.Dialog.Body>
            {alertMode
              ? icon || (
                  <div style={{ height: 80, textAlign: "center" }}>
                    <Glyphicon glyph="warning_sign" style={{ fontSize: 50, color: "#F9CE30" }} />
                  </div>
                )
              : null}
            <div style={{ textAlign: "center", fontSize: 18 }}>{question}</div>
            {message ? <div style={{ paddingTop: 20, textAlign: "center" }}>{message}</div> : null}
          </Modal.Dialog.Body>
          <Modal.Dialog.Footer>
            <ButtonBar align={alertMode ? "center" : "right"}>
              {alertMode ? null : (
                <Box mr="3">
                  <Button
                    variant="minimal"
                    data-e2e={uiPrefix("modal-cancel-btn")}
                    className={uiPrefix("modal-cancel-btn")}
                    onClick={this._cancel}
                  >
                    {cancelBtn}
                  </Button>
                </Box>
              )}
              <Button
                variant="feature"
                data-e2e={uiPrefix("modal-confirm-btn")}
                className={uiPrefix("modal-confirm-btn")}
                onClick={this._confirm}
              >
                {confirmBtn}
              </Button>
            </ButtonBar>
          </Modal.Dialog.Footer>
        </Modal.Dialog>
      </Modal>
    );
  }
}

export default ActionConfirmModal;
